import { Box, Stack } from "@mui/material";
import { Custom } from "components";
import { useApp, useTheme } from "contexts";

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const Confirmation = ({ open, onClose, onConfirm }: Props) => {
  const { theme } = useTheme();
  const { t } = useApp();

  return (
    <Custom.Modal
      open={open}
      onClose={onClose}
      title={t.component.popup.confirmation.title}
    >
      <Box>
        <Stack spacing={theme.spacing.md} textAlign="center">
          <Custom.Typography size={theme.font.xs} weight={theme.font.bold}>
            {t.component.popup.confirmation.headline}
          </Custom.Typography>
          <Custom.Typography size={theme.font.xs} weight={theme.font.normal}>
            {t.component.popup.confirmation.description}
          </Custom.Typography>
        </Stack>

        <Custom.Button
          fullWidth
          variant="contained"
          sx={{ mt: theme.spacing.md }}
          onClick={onConfirm}
        >
          {t.action.confirm}
        </Custom.Button>

        <Custom.Button
          fullWidth
          variant="outlined"
          sx={{ mt: theme.spacing.sm }}
          onClick={onClose}
        >
          {t.action.return_page}
        </Custom.Button>
      </Box>
    </Custom.Modal>
  );
};
